import { useEffect, useState, useRef } from 'react';
import { Outlet, useNavigate } from 'react-router';
import { DASHBOARD, NAVIGATION } from '../types/enum';
import useAuth from '../hook/useAuth';
import useFirebase from '../hook/useFirebase';
import BottomNav from './nav/bottom';
import Message from './message';
import Notification from './notification';
import Marquee from '../components/marque';
// import request from '../lib/request';
import PopUpNotification from '../components/popupNotification';
import Loading from '../components/loading';
import MediaNotification from './mediaNotification';
import PayDialog from '../components/premium/payDialog';

const Layout = () => {
  const { loading, user, signIn, signOut, refreshUser } = useAuth();
  const navigate = useNavigate();
  useFirebase(user);

  const payDialogRef = useRef(null);

  const [currentNav, setCurrentNav] = useState(NAVIGATION.DASHBOARD);
  const [dashboardSection, setDashboardSection] = useState(DASHBOARD.HOME);
  const [popUpQue, setPopUpQue] = useState([]);

  useEffect(() => {
    if (!loading && (!user || (user && !user.email))) {
      navigate('/start');
    }
  }, [user, loading]);

  useEffect(() => {
    // getSystemNotification();
  }, []);

  const handleCurrentNav = (nav) => () => {
    setCurrentNav(nav);
  };

  const handleDashboardSection = (section) => () => {
    setDashboardSection(section);
  };

  const handleClose = () => {
    let systemIds = localStorage.getItem('systemN');
    if (systemIds) {
      systemIds = JSON.parse(systemIds);
    } else {
      systemIds = [];
    }

    systemIds.push(popUpQue[0].id);
    localStorage.setItem('systemN', JSON.stringify(systemIds));

    const restPopUps = popUpQue.slice(1);
    setPopUpQue(restPopUps);

    if (restPopUps.length === 0) {
      window.location.reload();
    }
  };

  // const getSystemNotification = async () => {
  //   try {
  //     let { result } = await request.get('/notification/system');
  //     if (result?.length > 0) {
  //       let systemIds = localStorage.getItem('systemN');
  //       if (systemIds) {
  //         systemIds = JSON.parse(systemIds);
  //         result = result.filter((res) => !systemIds.includes(res.id));
  //       }
  //       setPopUpQue(result);
  //     } else {
  //       localStorage.removeItem('systemN');
  //     }
  //   } catch (err) {
  //     console.log(err);
  //   }
  // };

  const openPayDialog = () => {
    payDialogRef.current.showModal();
  };

  const closePayDialog = () => {
    payDialogRef.current.close();
  };

  return loading ? (
    <div className='flex items-center justify-center min-h-dvh bg-primary'>
      <div className='flex flex-col items-center space-y-4'>
        <Loading />
        <div className={`text-lg font-medium text-white`}>Loading...</div>
      </div>
    </div>
  ) : (
    user?.email && (
      <>
        <Marquee
          type='SYSTEM'
          icon={true}
        />
        <div className='relative min-h-dvh max-w-lg mx-auto bg-primary scrollbar-hidden'>
          <Outlet
            context={{
              loading,
              user,
              signIn,
              signOut,
              currentNav,
              handleCurrentNav,
              dashboardSection,
              handleDashboardSection,
              refreshUser,
            }}
          />
          {user.programRegistered && (
            <Message
              user={user}
              currentNav={currentNav}
            />
          )}
          <Notification
            currentNav={currentNav}
            handleCurrentNav={handleCurrentNav}
          />
          {popUpQue[0] && (
            <PopUpNotification
              open={Boolean(popUpQue[0])}
              title={popUpQue[0].title}
              close={handleClose}
            >
              <div className='whitespace-pre-line'>{popUpQue[0].content}</div>
            </PopUpNotification>
          )}
          <MediaNotification
            user={user}
            openPayDialog={openPayDialog}
          />
          <PayDialog
            dialogRef={payDialogRef}
            title='Go Premium'
            refreshUser={refreshUser}
            closeDialog={closePayDialog}
          />
        </div>
        <BottomNav
          currentNav={currentNav}
          handleCurrentNav={handleCurrentNav}
        />
      </>
    )
  );
};

export default Layout;
